export const SQ_SET_TAB = 'SQ_SET_TAB';
export const SQ_SET_INPUT = 'SQ_SET_INPUT';
export const SQ_CLEAR_CONVERSATION = 'SQ_CLEAR_CONVERSATION';

// Workspace
export const SQ_LOAD_WORKSPACE_REQUEST = 'SQ_LOAD_WORKSPACE_REQUEST';
export const SQ_LOAD_WORKSPACE_SUCCESS = 'SQ_LOAD_WORKSPACE_SUCCESS';
export const SQ_LOAD_WORKSPACE_ERROR   = 'SQ_LOAD_WORKSPACE_ERROR';

// Chat
export const SQ_SEND_MESSAGE_REQUEST = 'SQ_SEND_MESSAGE_REQUEST';
export const SQ_SEND_MESSAGE_SUCCESS = 'SQ_SEND_MESSAGE_SUCCESS';
export const SQ_SEND_MESSAGE_ERROR   = 'SQ_SEND_MESSAGE_ERROR';

// Saved queries
export const SQ_SAVE_QUERY_REQUEST = 'SQ_SAVE_QUERY_REQUEST';
export const SQ_SAVE_QUERY_SUCCESS = 'SQ_SAVE_QUERY_SUCCESS';
export const SQ_SAVE_QUERY_ERROR   = 'SQ_SAVE_QUERY_ERROR';

export const SQ_DELETE_SAVED_QUERY_REQUEST = 'SQ_DELETE_SAVED_QUERY_REQUEST';
export const SQ_DELETE_SAVED_QUERY_SUCCESS = 'SQ_DELETE_SAVED_QUERY_SUCCESS';
export const SQ_DELETE_SAVED_QUERY_ERROR   = 'SQ_DELETE_SAVED_QUERY_ERROR';

// Execute saved query
export const SQ_EXECUTE_QUERY_REQUEST = 'SQ_EXECUTE_QUERY_REQUEST';
export const SQ_EXECUTE_QUERY_SUCCESS = 'SQ_EXECUTE_QUERY_SUCCESS';
export const SQ_EXECUTE_QUERY_ERROR   = 'SQ_EXECUTE_QUERY_ERROR';

// Feedback
export const SQ_SEND_FEEDBACK_REQUEST = 'SQ_SEND_FEEDBACK_REQUEST';
export const SQ_SEND_FEEDBACK_SUCCESS = 'SQ_SEND_FEEDBACK_SUCCESS';



// WEBPACK FOOTER //
// ./src/containers/smart-queries/store/types.js